import queryString from 'query-string';
import request from './request.js';

/**
 *
 * @param {*} cursor
 * @param {*} query
 */
function getAll(cursor, query = false) {
    const encodedQuery = query ? encodeURIComponent(query) : '';
    const endpoint = `/accounts?cursor=${ cursor }&query=${ encodedQuery }`;
    const options = {
        endpoint,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param {*} cursor
 * @param {*} query
 */
function getReviewAccounts(cursor, query = false) {
    const encodedQuery = query ? encodeURIComponent(query) : '';
    const endpoint = `/accounts/review?cursor=${ cursor }&query=${ encodedQuery }`;
    const options = {
        endpoint,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param {*} cursor
 * @param {*} query
 * @param {*} body
 */
function getSpecific(query, cursor, status, advisorID) {
    const endpoint = '/accounts/specific';
    const options = {
        endpoint,
        method: 'POST',
        body: {
            query,
            cursor,
            status,
            advisorID
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param accountID
 * @param statuses
 * @returns {Promise<unknown>}
 */
function getRenewalPeriods(accountID, statuses) {
    let endpoint = `/accounts/${ accountID }/renewalPeriods`;
    if (Array.isArray(statuses) && statuses.every((e) => typeof e === 'string')) {
        endpoint += `?${ queryString.stringify({ statuses }) }`;
    }

    const options = {
        endpoint,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param groupNum
 * @returns {Promise<unknown>}
 */
function getAccountByGroupNum(groupNum) {
    const options = {
        endpoint: `/accounts/groupNum/${ groupNum }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param {*} accountID
 */
function get(accountID) {
    const options = {
        endpoint: `/accounts/${ accountID }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param {*} accountID
 * @param {*} body
 */
function updateAccount(accountID, body) {
    const options = {
        endpoint: `/accounts/${ accountID }`,
        method: 'PUT',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * Get the plan for the account
 * @param accountID
 * @returns {Promise<any>}
 */
function getPlan(accountID) {
    const options = {
        method: 'GET',
        endpoint: `/plan/${ accountID }`
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * Customize and update current plan, per class
 * @param body
 * @param classID
 * @returns {Promise<any>}
 */
function updatePlan(classID, body) {
    const options = {
        method: 'PUT',
        endpoint: `/plan/${ classID }`,
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param {*} accountID
 * @param {*} body
 */
function notifyAllUsers(accountID, body) {
    const options = {
        method: 'POST',
        endpoint: `/accounts/${ accountID }/notify/users`,
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param {*} userID
 * @param {*} accountID
 * @param {*} body
 */
function notifyUser(userID, accountID, body) {
    const options = {
        method: 'POST',
        endpoint: `/accounts/${ accountID }/notify/users/${ userID }`,
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * Add a user to the team
 * @param body
 * @param accountID
 * @returns {Promise<any>}
 */
function addUser(body, accountID) {
    const endpoint = `/user/${ accountID }`;
    const options = {
        method: 'POST',
        endpoint,
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * Update a user in the census
 * @param body
 * @param userID
 * @returns {Promise<any>}
 */
function updateUser(body, userID) {
    const endpoint = `/user/${ userID }`;
    const options = {
        method: 'PUT',
        endpoint,
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * Remove a user from the census
 * @param userID
 * @param accountID
 * @param effectiveDate
 * @returns {Promise<any>}
 */
function removeUser(userID, accountID, effectiveDate) {
    const endpoint = `/user/${ userID }/${ accountID }`;
    const options = {
        method: 'DELETE',
        endpoint,
        body: {
            effectiveDate
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * Remove a user from the census
 * @param userID
 * @param accountID
 * @param effectiveDate
 * @returns {Promise<any>}
 */
function getUsers(accountID, filters) {
    const endpoint = `/accounts/${ accountID }/getUsers`;
    const options = {
        method: 'POST',
        endpoint,
        body: {
            classes: filters.classes,
            divisions: filters.divisions,
            status: filters.status,
            hireDate: filters.hireDate,
            studyStartDate: filters.studyStartDate,
            waivedStatus: filters.waivedStatus
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param title
 * @param description
 * @param accountID
 * @param quoteID
 * @param revisionID
 * @returns {Promise<unknown>}
 */
function addClass(title, description, isRetiree, accountID, quoteID, revisionID) {
    const endpoint = `/class/${ accountID }`;
    const options = {
        method: 'POST',
        endpoint,
        body: {
            title,
            description,
            isRetiree,
            quoteID: quoteID || null,
            revisionID: revisionID || null
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param title
 * @param description
 * @param isRetiree
 * @param earningsDefinition
 * @param classID
 * @param accountID
 * @param quoteID
 * @param revisionID
 * @returns {Promise<unknown>}
 */
function editClass(title, description, isRetiree, earningsDefinition, classID, accountID, quoteID = null, revisionID = null) {
    const endpoint = `/class/${ accountID }/${ classID }`;
    const options = {
        method: 'PUT',
        endpoint,
        body: {
            title,
            description,
            isRetiree,
            earningsDefinition,
            quoteID: quoteID || null,
            revisionID: revisionID || null
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param title
 * @param description
 * @param address
 * @param bankingDetails
 * @param accountID
 * @param quoteID
 * @param revisionID
 * @param numberOfPrivateLabelLives
 * @returns {Promise<unknown>}
 */
function addDivision(title, description, address, bankingDetails, accountID, quoteID = null, revisionID = null, numberOfPrivateLabelLives = null) {
    const endpoint = `/division/${ accountID }`;
    const options = {
        method: 'POST',
        endpoint,
        body: {
            title,
            description,
            address,
            bankingDetails,
            quoteID: quoteID || null,
            revisionID: revisionID || null,
            numberOfPrivateLabelLives
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param title
 * @param description
 * @param address
 * @param bankingDetails
 * @param accountID
 * @param divisionID
 * @param quoteID
 * @param revisionID
 * @param numberOfPrivateLabelLives
 * @returns {Promise<unknown>}
 */
function editDivision(title, description, address, bankingDetails, accountID, divisionID, quoteID, revisionID, numberOfPrivateLabelLives = null) {
    const endpoint = `/division/${ accountID }/${ divisionID }`;

    const options = {
        method: 'PUT',
        endpoint,
        body: {
            title,
            description,
            numberOfPrivateLabelLives,
            address,
            bankingDetails,
            quoteID: quoteID || null,
            revisionID: revisionID || null
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param data
 * @param accountID
 * @returns {Promise<any>}
 */
function createAdmin(data, accountID) {
    const options = {
        endpoint: `/admin/${ accountID }`,
        method: 'POST',
        body: {
            email: data.email,
            firstname: data.firstname,
            lastname: data.lastname,
            language: data.language,
            isParent: data.isParent,
            selectedDivisions: data.selectedDivisions,
            useMFA: Boolean(data.useMFA)
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param adminID
 * @returns {Promise<any>}
 */
function removeAdmin(adminID) {
    const options = {
        endpoint: `/admin/${ adminID }`,
        method: 'DELETE'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param data
 * @param adminID
 * @returns {Promise<any>}
 */
function updateAdmin(data, adminID) {
    const options = {
        endpoint: `/admin/${ adminID }`,
        method: 'PUT',
        body: {
            email: data.email,
            firstname: data.firstname,
            lastname: data.lastname,
            language: data.language,
            isParent: data.isParent,
            selectedDivisions: data.selectedDivisions,
            useMFA: Boolean(data.useMFA)
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param quoteID
 * @returns {Promise<unknown>}
 */
function getAccountHistoryKeys(accountID, quoteID = null) {
    const options = {
        endpoint: quoteID ? `/accounts/${ accountID }/history?quoteID=${ quoteID }` : `/accounts/${ accountID }/history`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param body
 * @param accountID
 * @param quoteID
 * @returns {Promise<unknown>}
 */
function uploadAccountHistory(body, accountID, quoteID) {
    body.append('quoteID', quoteID || null);

    const options = {
        endpoint: `/accounts/${ accountID }/accountHistory/upload`,
        method: 'POST',
        noJson: true,
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param classID
 * @param designID
 * @param data
 * @param quoteID
 * @param revisionID
 * @param effectiveDate
 * @returns {Promise<unknown>}
 */
function savePricing(classID, designID, data, quoteID, revisionID, effectiveDate) {
    const options = {
        endpoint: `/plan/${ classID }/${ designID }/pricing`,
        method: 'POST',
        body: {
            ...data,
            quoteID: quoteID || null,
            revisionID: revisionID || null,
            effectiveDate: effectiveDate || null
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param telusDrugPlanID
 * @param designID
 * @param quoteID
 * @param revisionID
 * @returns {Promise<unknown>}
 */
function saveTelusDrugPlanID(telusDrugPlanID, designID, quoteID, revisionID) {
    const options = {
        endpoint: `/plan/${ designID }/telusDrugPlanID/${ telusDrugPlanID }`,
        method: 'POST',
        body: {
            quoteID: quoteID || null,
            revisionID: revisionID || null
        }

    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param quoteID
 * @param revisionID
 * @returns {Promise<unknown>}
 */
function submitPricing(accountID, quoteID, revisionID) {
    const options = {
        endpoint: `/plan/${ accountID }/pricing/submit`,
        method: 'POST',
        body: {
            quoteID: quoteID || null,
            revisionID: revisionID || null
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @returns {Promise<any>}
 */
function giveGoLiveAccess(accountID) {
    const options = {
        endpoint: `/account/${ accountID }/giveGoLiveAccess`,
        method: 'POST'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param quoteID
 * @returns {Promise<unknown>}
 */
function getMasterApplicationData(accountID, quoteID = false) {
    const options = {
        endpoint: quoteID ? `/accounts/${ accountID }/masterApplication?quoteID=${ quoteID }` : `/accounts/${ accountID }/masterApplication`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param body
 * @param quoteID
 * @returns {Promise<unknown>}
 */
function updateMasterApp(accountID, body, quoteID) {
    const options = {
        endpoint: `/accounts/${ accountID }/masterApplication`,
        method: 'PUT',
        body: {
            ...body,
            quoteID: quoteID || null
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @returns {Promise<any>}
 */
function setMasterAppBack(accountID) {
    const options = {
        endpoint: `/accounts/${ accountID }/masterApplication/setBack`,
        method: 'POST'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * The advisor is done with the master app so lets complete and move to the next step
 * @param accountID
 * @param quoteID
 * @returns {Promise<any>}
 */
function completeMasterApp(accountID, quoteID) {
    const options = {
        endpoint: `/accounts/${ accountID }/masterApplication/complete`,
        method: 'POST',
        body: {
            quoteID: quoteID || null
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param body
 * @returns {Promise<any>}
 */
function sendForgotPassword(body) {
    const options = {
        endpoint: '/admin/sendForgotPassword',
        method: 'POST',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 */
function allowEnrollments(accountID) {
    const options = {
        endpoint: `/accounts/${ accountID }/allowEnrollments`,
        method: 'POST'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param designID
 * @param body
 * @param quoteID
 * @param revisionID
 * @param effectiveDate
 * @returns {Promise<unknown>}
 */
function saveDesign(designID, body, quoteID, revisionID, effectiveDate) {
    const endpoint = `/plan/design/${ designID }`;
    const options = {
        method: 'PUT',
        endpoint,
        body: {
            ...body,
            quoteID: quoteID || null,
            revisionID: revisionID || null,
            effectiveDate: effectiveDate || null
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param classID
 * @param body
 * @param quoteID
 * @param revisionID
 * @param effectiveDate
 * @returns {Promise<unknown>}
 */
function saveModularBlueprint(classID, body, quoteID, revisionID, effectiveDate) {
    const options = {
        method: 'PUT',
        endpoint: `/plan/${ classID }/modularFlex/blueprint`,
        body: {
            ...body,
            quoteID: quoteID || null,
            revisionID: revisionID || null,
            effectiveDate: effectiveDate || null
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @returns {Promise<any>}
 */
function getInvoices(accountID) {
    const endpoint = `/invoices/${ accountID }`;
    const options = {
        method: 'GET',
        endpoint
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param asoReportID
 * @returns {Promise<unknown>}
 */
function getAsoReport(asoReportID) {
    const endpoint = `/invoices/asoReport/${ asoReportID }`;
    const options = {
        method: 'GET',
        endpoint
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param invoiceNum
 * @returns {Promise<unknown>}
 */
function getInvoice(accountID, invoiceNum) {
    const endpoint = `/invoices/${ accountID }/${ invoiceNum }`;
    const options = {
        method: 'GET',
        endpoint
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param invoiceNum
 * @returns {Promise<unknown>}
 */
function getCurrentInvoice(accountID) {
    const endpoint = `/invoices/current/${ accountID }`;
    const options = {
        method: 'GET',
        endpoint
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * 
 * @param {*} invoiceNum 
 * @param {*} accountID 
 * @param {*} isDivisionSummary 
 * @param {*} selectedDivisionID 
 * @returns 
 */
function generateInvoiceSpreadsheet(invoiceNum, accountID, isDivisionSummary, selectedDivisionID) {
    const options = {
        endpoint: '/invoices/generateSpreadsheet',
        method: 'POST',
        body: {
            invoiceNum,
            accountID,
            isDivisionSummary,
            selectedDivisionID
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param designID
 * @param quoteID
 * @returns {Promise<unknown>}
 */
function getPlanDesignRevisions(designID, quoteID) {
    const endpoint = quoteID ? `/plan/design/${ designID }/revisions?quoteID=${ quoteID }` : `/plan/design/${ designID }/revisions`;
    const options = {
        method: 'GET',
        endpoint
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param revisionID
 * @param quoteID
 * @returns {Promise<unknown>}
 */
function getSinglePlanDesignRevision(revisionID, quoteID) {
    const endpoint = quoteID ? `/plan/design/revisions/${ revisionID }?quoteID=${ quoteID }` : `/plan/design/revisions/${ revisionID }`;
    const options = {
        method: 'GET',
        endpoint
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param designID
 * @param quoteID
 * @returns {Promise<unknown>}
 */
function getPricingRevisions(designID, quoteID = null) {
    const endpoint = quoteID ? `/plan/pricing/${ designID }/revisions?quoteID=${ quoteID }` : `/plan/pricing/${ designID }/revisions`;
    const options = {
        method: 'GET',
        endpoint
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param revisionID
 * @param quoteID
 * @returns {Promise<unknown>}
 */
function getSinglePricingRevision(revisionID, quoteID) {
    const endpoint = quoteID ? `/plan/pricing/revisions/${ revisionID }?quoteID=${ quoteID }` : `/plan/pricing/revisions/${ revisionID }`;
    const options = {
        method: 'GET',
        endpoint
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param commissions
 * @param quoteID
 * @param revisionID
 * @param effectiveDate
 * @returns {Promise<unknown>}
 */
function saveCommissions(accountID, commissions, quoteID, revisionID, effectiveDate) {
    const options = {
        endpoint: `/accounts/${ accountID }/commissions`,
        method: 'POST',
        body: {
            ...commissions,
            quoteID: quoteID || null,
            revisionID: revisionID || null,
            effectiveDate: effectiveDate || null
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param commissions
 * @param quoteID
 * @param revisionID
 * @returns {Promise<unknown>}
 */
function submitCommission(accountID, commissions, quoteID, revisionID) {
    const options = {
        endpoint: `/accounts/${ accountID }/commissions/submit`,
        method: 'POST',
        body: {
            ...commissions,
            quoteID: quoteID || null,
            revisionID: revisionID || null
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param quoteID
 * @param revisionID
 * @returns {Promise<unknown>}
 */
function getCommissions(accountID, quoteID = null, revisionID = null) {
    let endpoint = `/accounts/${ accountID }/commissions`;

    if (quoteID) {
        endpoint = `/accounts/${ accountID }/commissions?quoteID=${ quoteID }`;
    }

    if (revisionID) {
        endpoint = `/accounts/${ accountID }/commissions?revisionID=${ revisionID }`;
    }

    const options = {
        endpoint,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @returns {Promise<any>}
 */
function submitCensus(accountID) {
    const options = {
        method: 'POST',
        endpoint: `/accounts/${ accountID }/census/submit`
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param accountID
 * @param body
 * @returns {Promise<unknown>}
 */
function uploadMassUpdateForm(accountID, body) {
    const options = {
        endpoint: `/accounts/${ accountID }/massUpdate/upload`,
        method: 'POST',
        noJson: true,
        body
    };
    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @returns {Promise}
 */
function downloadSalaryUpdateData(accountID) {
    const options = {
        endpoint: `/accounts/${ accountID }/massSalaryFile`,
        method: 'GET'
    };
    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * Add census form
 * @param accountID
 * @param body
 * @returns {Promise<any>}
 */
function uploadMassSalaryForm(accountID, body) {
    const options = {
        endpoint: `/accounts/${ accountID }/massSalaryFile`,
        method: 'POST',
        noJson: true,
        body
    };
    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * Add census form
 * @param body
 * @param accountID
 * @returns {Promise<any>}
 */
function uploadCensus(body, accountID) {
    const options = {
        endpoint: `/accounts/${ accountID }/census/upload`,
        method: 'POST',
        noJson: true,
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param {*} classID
 * @param {*} accountID
 * @param {*} body
 * @returns
 */
function uploadMemberBooklet(classID, accountID, body) {
    const endpoint = `/class/${ classID }/${ accountID }/documents/upload`;
    const options = {
        endpoint,
        method: 'POST',
        noJson: true,
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param status
 * @returns {Promise<unknown>}
 */
function changeBookletStatusForAccount(accountID, status) {
    const endpoint = `/accounts/${ accountID }/booklets/status`;
    const options = {
        endpoint,
        method: 'PUT',
        body: {
            status
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param classID
 * @param status
 * @returns {Promise<unknown>}
 */
function changeBookletStatusForClass(classID, status) {
    const endpoint = `/class/${ classID }/booklets/status`;
    const options = {
        endpoint,
        method: 'PUT',
        body: {
            status
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param {*} classID
 * @param {*} accountID
 * @param {*} body
 * @returns
 */
function removeMemberBooklet(classID, accountID) {
    const options = {
        endpoint: `/class/${ classID }/${ accountID }/documents/remove`,
        method: 'DELETE'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param quoteID
 * @returns {Promise<unknown>}
 */
function sendMasterAppLink(accountID, quoteID) {
    const options = {
        endpoint: `/accounts/${ accountID }/masterApplication/sendLink`,
        method: 'POST',
        body: {
            quoteID: quoteID || null
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param effDate
 * @returns {Promise<unknown>}
 */
function makeAccountLive(accountID, effDate) {
    const options = {
        endpoint: `/accounts/${ accountID }/goLive`,
        method: 'POST',
        body: {
            effDate
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param quoteID
 * @param revisionID
 * @returns {Promise<unknown>}
 */
function submitPlanDesigns(accountID, quoteID, revisionID) {
    const options = {
        method: 'POST',
        endpoint: `/plan/design/${ accountID }/submit`,
        body: {
            quoteID: quoteID || null,
            revisionID: revisionID || null
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param quoteID
 * @param revisionID
 * @returns {Promise<unknown>}
 */
function submitModuleBlueprint(accountID, quoteID, revisionID) {
    const options = {
        method: 'POST',
        endpoint: `/plan/modularFlex/${ accountID }/submit`,
        body: {
            quoteID: quoteID || null,
            revisionID: revisionID || null
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param classID
 * @param planDesign
 * @param quoteID
 * @param revisionID
 * @returns {Promise<unknown>}
 */
function createDesignFromUpload(classID, planDesign, quoteID, revisionID) {
    const endpoint = `/plan/design/${ classID }`;
    const options = {
        method: 'POST',
        endpoint,
        body: {
            quoteID: quoteID || null,
            revisionID: revisionID || null,
            defaultData: {
                ...planDesign,
                designID: null
            }
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param classID
 * @param quoteID
 * @param revisionID
 * @returns {Promise<unknown>}
 */
function createDesign(classID, quoteID, revisionID) {
    const endpoint = `/plan/design/${ classID }`;
    const options = {
        method: 'POST',
        endpoint,
        body: {
            quoteID: quoteID || null,
            revisionID: revisionID || null
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param designID
 * @param quoteID
 * @param revisionID
 * @returns {Promise<unknown>}
 */
function cloneDesign(designID, quoteID, revisionID) {
    const endpoint = `/plan/design/${ designID }/clone`;
    const options = {
        method: 'POST',
        endpoint,
        body: {
            quoteID: quoteID || null,
            revisionID: revisionID || null
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param reason
 * @param quoteID
 * @returns {Promise<unknown>}
 */
function rejectPricing(accountID, reason, quoteID) {
    const options = {
        endpoint: `/accounts/${ accountID }/pricing/reject`,
        method: 'POST',
        body: {
            reason,
            quoteID: quoteID
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param assignments
 * @param quoteID
 * @param revisionID
 * @returns {Promise<unknown>}
 */
function assignPlans(accountID, assignments, quoteID, revisionID) {
    const options = {
        endpoint: `/accounts/${ accountID }/class/assignPlans`,
        method: 'POST',
        body: {
            assignments,
            quoteID: quoteID || null,
            revisionID: revisionID || null
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param divisionID
 * @param invoiceNum
 * @returns {Promise<unknown>}
 */
function triggerDivisionRepayment(accountID, divisionID, invoiceNum) {
    const options = {
        endpoint: `/accounts/${ accountID }/divisions/${ divisionID }/paymentCarryForward`,
        method: 'POST',
        body: {
            invoiceNum
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @returns {Promise<unknown>}
 */
function getRenewals(accountID) {
    const options = {
        endpoint: `/accounts/${ accountID }/renewals`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @returns {Promise<unknown>}
 */
function getRenewalFormData(accountID, renewalID) {
    const options = {
        endpoint: `/accounts/${ accountID }/renewals/${ renewalID }/form`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**

 * @param accountID
 * @returns {Promise<unknown>}
 */
function getPreviousRenewalFormData(accountID, renewalID) {
    const options = {
        endpoint: `/accounts/${ accountID }/renewals/${ renewalID }/previous/form`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param accountID
 * @returns {Promise<unknown>}
 */
function getDivisions(accountID) {
    const options = {
        endpoint: `/division/${ accountID }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param accountID
 * @returns {Promise<unknown>}
 */
function getClasses(accountID) {
    const options = {
        endpoint: `/class/${ accountID }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param body
 * @param uid
 * @param accountID
 * @returns {Promise<unknown>}
 */
function uploadRenewalFile(body, uid, accountID) {
    const options = {
        endpoint: `/accounts/${ accountID }/renewals/${ uid }/file/upload`,
        method: 'POST',
        noJson: true,
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param renewalID
 * @returns {Promise<unknown>}
 */
function completeRenewal(accountID, renewalID) {
    const options = {
        endpoint: `/accounts/${ accountID }/renewals/${ renewalID }/complete`,
        method: 'POST'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param revisionID
 * @returns {Promise<unknown>}
 */
function getRevision(revisionID) {
    const options = {
        endpoint: `/accounts/revisions/${ revisionID }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param amendmentID
 * @returns {Promise<unknown>}
 */
function createRevision(accountID, amendmentID) {
    const options = {
        endpoint: `/accounts/${ accountID }/revisions/${ amendmentID }`,
        method: 'POST'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param revisionID
 * @param body
 * @returns {Promise<unknown>}
 */
function editRevision(revisionID, body) {
    const options = {
        endpoint: `/accounts/revisions/${ revisionID }`,
        method: 'PUT',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param revisionID
 * @returns {Promise<unknown>}
 */
function completeRevisions(accountID, revisionID) {
    const options = {
        endpoint: `/accounts/${ accountID }/revisions/${ revisionID }/complete`,
        method: 'POST'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @returns {Promise<unknown>}
 */
function getAmendments(accountID) {
    const options = {
        endpoint: `/accounts/${ accountID }/amendments`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param amendmentID
 * @returns {Promise<unknown>}
 */
function getAmendment(accountID, amendmentID) {
    const options = {
        endpoint: `/accounts/${ accountID }/amendments/${ amendmentID }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}


/**
 * @param accountID
 * @returns {Promise<unknown>}
 */
function createAmendment(accountID) {
    const options = {
        endpoint: `/accounts/${ accountID }/amendments`,
        method: 'POST',
        body: {}
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param amendmentID
 * @param amendment
 * @returns {Promise<unknown>}
 */
function saveAmendment(accountID, amendmentID, amendment) {
    const options = {
        endpoint: `/accounts/${ accountID }/amendments/${ amendmentID }`,
        method: 'PUT',
        body: {
            ...amendment
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param amendmentID
 */
function sendAmendmentForApproval(accountID, amendmentID) {
    const options = {
        endpoint: `/accounts/${ accountID }/amendments/${ amendmentID }/sendApproval`,
        method: 'POST',
        body: {}
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @returns {Promise<unknown>}
 */
function getPendingChanges(accountID) {
    const options = {
        endpoint: `/accounts/${ accountID }/pendingChanges`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param changeID
 * @param accountID
 * @returns {Promise<unknown>}
 */
function getPendingChangeData(changeID, accountID) {
    const options = {
        endpoint: `/accounts/${ accountID }/pendingChanges/${ changeID }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param changeID
 * @param accountID
 * @returns {Promise<unknown>}
 */
function removePendingChange(changeID, accountID) {
    const options = {
        endpoint: `/accounts/${ accountID }/pendingChanges/${ changeID }`,
        method: 'DELETE'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @returns {Promise<unknown>}
 */
function getLsaItems(accountID) {
    const options = {
        endpoint: `/accounts/${ accountID }/lsaItems`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param lsaItems
 * @returns {Promise<unknown>}
 */
function saveLsaItems(accountID, lsaItems) {
    const options = {
        endpoint: `/accounts/${ accountID }/lsaItems`,
        method: 'POST',
        body: {
            lsaItems
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param lsaItems
 * @returns {Promise<unknown>}
 */
function terminateAccount(accountID, effectiveDate) {
    const options = {
        endpoint: `/accounts/${ accountID }/terminate`,
        method: 'POST',
        body: {
            effectiveDate
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param classID
 * @param divisionID
 * @param renewalID
 * @returns {Promise<unknown>}
 */
function getAccountNotes(accountID, classID = null, divisionID = null, getRenewalsNotes = null) {
    const queryParams = new URLSearchParams({
        ...(classID ? { classID } : {}),
        ...(divisionID ? { divisionID } : {}),
        ...(getRenewalsNotes ? { getRenewalsNotes } : {})
    });

    const options = {
        method: 'GET',
        endpoint: `/accounts/${ accountID }/notes?${ queryParams.toString() }`
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param classID
 * @param divisionID
 * @param renewalID
 * @param body
 * @param expiry
 * @returns {Promise<unknown>}
 */
function createAccountNote(accountID, classID, divisionID, renewalID, body, expiry) {
    const options = {
        endpoint: `/accounts/${ accountID }/note`,
        method: 'POST',
        body: {
            body,
            ...(classID ? { classID } : {}),
            ...(divisionID ? { divisionID } : {}),
            ...(renewalID ? { renewalID } : {}),
            expiry
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param accNoteID
 * @returns {Promise<unknown>}
 */
function removeAccountNote(accountID, accNoteID) {
    const options = {
        endpoint: `/accounts/${ accountID }/notes/${ accNoteID }`,
        method: 'DELETE'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param advisorID
 */
function getSpecialityProductMetaConfigs(advisorID) {
    const options = {
        endpoint: `/plan/${ advisorID }/specialityProducts/configs`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param advisorID
 * @param quoteID
 * @returns {Promise<unknown>}
 */
function getSpecialityProductRates(accountID, advisorID, quoteID) {
    const options = {
        endpoint: quoteID ? `/plan/${ advisorID }/${ accountID }/specialityProducts/rates?quoteID=${ quoteID }` : `/plan/${ advisorID }/${ accountID }/specialityProducts/rates`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param quoteID
 * @param rates
 * @param effectiveDate
 * @returns {Promise<unknown>}
 */
function saveSpecialityProductRates(accountID, quoteID, rates, effectiveDate = null) {
    const endpoint = `/plan/${ accountID }/specialityProducts/rates`;
    const options = {
        method: 'POST',
        endpoint,
        body: {
            quoteID: quoteID || null,
            rates,
            effectiveDate
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param advisorID
 * @param quoteID
 * @param rates
 * @returns {Promise<unknown>}
 */
function submitSpecialityProductRates(accountID, advisorID, quoteID, rates) {
    const endpoint = `/plan/${ advisorID }/${ accountID }/specialityProducts/rates/submit`;
    const options = {
        method: 'POST',
        endpoint,
        body: {
            quoteID: quoteID || null,
            rates
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @returns {Promise<unknown>}
 */
function getCommissionSplits(accountID) {
    const options = {
        endpoint: `/accounts/${ accountID }/commissions/split`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param accountID
 * @param commissionSplitData
 * @returns {Promise<unknown>}
 */
function replaceCommissionSplits(accountID, commissionSplitData) {
    const endpoint = `/accounts/${ accountID }/commissions/split`;

    const options = {
        method: 'PUT',
        endpoint,
        body: {
            commissionSplitData
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param masterID
 * @param type
 * @param accountID
 * @returns {Promise<unknown>}
 */
function assignRepresentative(masterID, type, accountID) {
    const options = {
        method: 'POST',
        endpoint: `/accounts/${ accountID }/representatives`,
        body: {
            masterID,
            type
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param masterID
 * @param accountID
 * @returns {Promise<unknown>}
 */
function removeRepresentative(masterID, accountID) {
    const options = {
        method: 'DELETE',
        endpoint: `/accounts/${ accountID }/representatives/${ masterID }`
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

export {
    getAll,
    getReviewAccounts,
    getRenewalPeriods,
    getAccountByGroupNum,
    get,
    getSpecific,
    updateAccount,
    getPlan,
    updatePlan,
    notifyAllUsers,
    notifyUser,
    addUser,
    updateUser,
    removeUser,
    getUsers,
    addClass,
    editClass,
    addDivision,
    editDivision,
    createAdmin,
    updateAdmin,
    removeAdmin,
    getAccountHistoryKeys,
    uploadMassUpdateForm,
    downloadSalaryUpdateData,
    uploadMassSalaryForm,
    savePricing,
    submitPricing,
    giveGoLiveAccess,
    setMasterAppBack,
    sendForgotPassword,
    saveTelusDrugPlanID,
    allowEnrollments,
    saveDesign,
    getInvoice,
    getInvoices,
    getAsoReport,
    getPlanDesignRevisions,
    getSinglePlanDesignRevision,
    getPricingRevisions,
    getSinglePricingRevision,
    saveModularBlueprint,
    uploadMemberBooklet,
    removeMemberBooklet,
    uploadAccountHistory,
    saveCommissions,
    submitCommission,
    getCommissions,
    getMasterApplicationData,
    updateMasterApp,
    completeMasterApp,
    submitCensus,
    uploadCensus,
    sendMasterAppLink,
    makeAccountLive,
    submitPlanDesigns,
    submitModuleBlueprint,
    createDesign,
    createDesignFromUpload,
    cloneDesign,
    rejectPricing,
    assignPlans,
    triggerDivisionRepayment,
    getDivisions,
    getClasses,
    getRenewals,
    getRenewalFormData,
    getPreviousRenewalFormData,
    uploadRenewalFile,
    completeRenewal,
    changeBookletStatusForAccount,
    changeBookletStatusForClass,
    getRevision,
    createRevision,
    editRevision,
    completeRevisions,
    getAmendments,
    getAmendment,
    createAmendment,
    saveAmendment,
    sendAmendmentForApproval,
    getPendingChanges,
    getPendingChangeData,
    removePendingChange,
    getLsaItems,
    saveLsaItems,
    terminateAccount,
    getCurrentInvoice,
    getAccountNotes,
    createAccountNote,
    removeAccountNote,
    getSpecialityProductMetaConfigs,
    getSpecialityProductRates,
    saveSpecialityProductRates,
    submitSpecialityProductRates,
    generateInvoiceSpreadsheet,
    getCommissionSplits,
    replaceCommissionSplits,
    assignRepresentative,
    removeRepresentative
};